// src/pages/Corpreg.jsx
import React, { useContext, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useCorpreg } from '@hooks';
import { AuthContext } from '@context';
import { AccountCreatedModal } from '@pages';
import './CorpregCustom.css';

export const Corpreg = () => {
  const { hasPermission } = useContext(AuthContext);
  const canWrite = hasPermission('COMPANY_WRITE');

  const [accountCreatedModal, setAccountCreatedModal] = useState({ isOpen: false, accountInfo: null });

  const corpregMethods = useCorpreg({
    onAccountCreated: (accountInfo) => {
      setAccountCreatedModal({ isOpen: true, accountInfo });
    },
  });
  const {
    register,
    formState: { errors },
    watch,
    handleFormSubmit,
    regionList,
    bizTypeList,
    managerList,
    isUser,
    isSuperAdmin,
    isR1Admin,
    currentUser,
    handleNumericKeyDown,
    handleNumericPaste,
    handleNumericDrop,
    handleCompositionStart,
    handleCompositionEnd,
    setValue,
  } = corpregMethods;

  // 비고 글자 수
  const noticeValue = watch("notice") || "";
  const noticeLength = noticeValue.length;

  // 담당자 멀티셀렉트
  const selectedManagerIds = watch("managerIds") || [];


  return (
      <>
      <AccountCreatedModal
        isOpen={accountCreatedModal.isOpen}
        onClose={() => {
          setAccountCreatedModal({ isOpen: false, accountInfo: null });
          window.location.reload();
        }}
        accountInfo={accountCreatedModal.accountInfo}
      />
      {/* FormProvider에 훅 반환값(methods) 전체를 넘김 */}
      <FormProvider {...corpregMethods}>
        <div className="contents-wrap">

          {/* 페이지 제목 */}
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>회사 정보</h2>
          </div>

          {/* 상단 버튼 (저장) */}
          <div className="section-tit-wrap">
            <div className="btn-right-box">
              <ul>
                {canWrite && (
                <li>
                  <button
                      type="button"
                      className="btn-save"
                      onClick={handleFormSubmit}
                  >
                    저장
                  </button>
                </li>
                )}
              </ul>
            </div>
          </div>

          <table className="table-write">
            <colgroup>
              <col style={{ width: '10%' }} />
              <col style={{ width: '40%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '40%' }} />
            </colgroup>
            <tbody>

            {/* 유저(ROLE_USER) 아닌 경우만 관할구역 / 사업장 코드 표시 */}
            {!isUser && (
                <tr>
                  <th>사업장 코드</th>
                  <td>
                    <input
                        type="text"
                        className="input-customtext"
                        readOnly
                        {...register("compCode")}
                        style={{ width: '200px' }}
                    />
                  </td>
                  <th>관할구역<span className="requiredcustom">*</span></th>
                  <td>
                    <select
                        className={`input-customselect ${errors.region ? "error" : ""}`}
                        {...register("region")}
                        style={{ width: '200px' }}
                    >
                      <option value="">관할구역 선택</option>
                      {regionList.map((r) => (
                          <option key={r.comdCode} value={r.comdCode}>
                            {r.comdName}
                          </option>
                      ))}
                    </select>
                    {errors.region && (
                        <p className="error-custommessage">{errors.region.message}</p>
                    )}
                  </td>
                </tr>
            )}

            {/* 유저(ROLE_USER)라면 region/compCode 감춤 
                => hidden input을 table 밖이나 감춰진 <tr>안에 배치 (DOM 오류 방지)
            */}
            {isUser && (
                <tr style={{ display: 'none' }}>
                  <td colSpan={4}>
                    <input type="hidden" {...register("compCode")} />
                    <input type="hidden" {...register("region")} />
                  </td>
                </tr>
            )}

            {/* 사업자등록번호 */}
            <tr>
              <th>사업자등록번호<span className="requiredcustom">*</span></th>
              <td>
                <input
                    type="text"
                    className={`input-customtext ${errors.bizNo ? "error" : ""}`}
                    placeholder="사업자등록번호(- 없이)"
                    style={{ width: '300px' }}
                    maxLength={10}
                    onKeyDown={handleNumericKeyDown}
                    onPaste={handleNumericPaste}
                    onDrop={handleNumericDrop}
                    onCompositionStart={handleCompositionStart}
                    onCompositionEnd={handleCompositionEnd}
                    {...register("bizNo")}
                />
                {errors.bizNo && (
                    <p className="error-custommessage">{errors.bizNo.message}</p>
                )}
              </td>
              <th>법인명(사업장명)<span className="requiredcustom">*</span></th>
              <td>
                <input
                    type="text"
                    className={`input-customtext ${errors.compName ? "error" : ""}`}
                    placeholder="사업장명"
                    style={{ width: '300px' }}
                    maxLength={20}
                    {...register("compName")}
                />
                {errors.compName && (
                    <p className="error-custommessage">{errors.compName.message}</p>
                )}
              </td>
            </tr>

            {/* ID 회사명 */}
            <tr>
              <th>ID 회사명<span className="requiredcustom">*</span><br/><span style={{fontSize:'11px',fontWeight:'normal',color:'#888'}}>(영문·한글, 특수문자 제외)</span></th>
              <td colSpan={3}>
                <input
                    type="text"
                    className={`input-customtext ${errors.engCompName ? "error" : ""}`}
                    placeholder="예: 아토스, atos"
                    style={{ width: '300px' }}
                    maxLength={100}
                    {...register("engCompName")}
                />
                {errors.engCompName && (
                    <p className="error-custommessage">{errors.engCompName.message}</p>
                )}
              </td>
            </tr>

            {/* 담당자 + 사용여부 */}
            <tr>
              {(isSuperAdmin || isR1Admin) ? (
                <>
                  <th>
                    담당자<br />
                    <span style={{ fontWeight: 'normal', fontSize: '11px', color: '#888' }}>(복수 선택 가능)</span>
                  </th>
                  <td>
                    <div
                      style={{
                        maxHeight: '130px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '6px 10px',
                        minWidth: '200px',
                        background: '#fff',
                      }}
                    >
                      {managerList.length === 0 ? (
                        <span style={{ color: '#999', fontSize: '12px' }}>담당자 없음</span>
                      ) : (
                        managerList.map((m) => {
                          const checked = selectedManagerIds.includes(m.id);
                          return (
                            <label
                              key={m.id}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                marginBottom: '4px',
                                cursor: 'pointer',
                                fontSize: '13px',
                              }}
                            >
                              <input
                                type="checkbox"
                                value={m.id}
                                checked={checked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setValue('managerIds', [...selectedManagerIds, m.id]);
                                  } else {
                                    setValue('managerIds', selectedManagerIds.filter((id) => id !== m.id));
                                  }
                                }}
                              />
                              {m.name}
                            </label>
                          );
                        })
                      )}
                    </div>
                  </td>
                </>
              ) : (
                <td colSpan={2} />
              )}
              <th>사용여부</th>
              <td>
                <select
                    className="input-customselect"
                    style={{ width: '120px' }}
                    {...register('useYn')}
                >
                  <option value="Y">사용</option>
                  <option value="N">미사용</option>
                </select>
              </td>
            </tr>

            {/* 대표자명, 전화번호 */}
            <tr>
              <th>대표자명<span className="requiredcustom">*</span></th>
              <td>
                <input
                    type="text"
                    className={`input-customtext ${errors.repName ? "error" : ""}`}
                    placeholder="대표자명"
                    style={{ width: '300px' }}
                    maxLength={20}
                    {...register("repName")}
                />
                {errors.repName && (
                    <p className="error-custommessage">{errors.repName.message}</p>
                )}
              </td>
              <th>전화번호</th>
              <td>
                <input
                    type="text"
                    className={`input-text ${errors.phone ? "error" : ""}`}
                    placeholder="전화번호(- 없이)"
                    style={{ width: '300px' }}
                    maxLength={11}
                    onKeyDown={handleNumericKeyDown}
                    onPaste={handleNumericPaste}
                    onDrop={handleNumericDrop}
                    onCompositionStart={handleCompositionStart}
                    onCompositionEnd={handleCompositionEnd}
                    {...register("phone")}
                />
                <p style={{ fontSize: '11px', color: '#888', margin: '3px 0 0' }}>- 없이 숫자만 입력하세요.</p>
                {errors.phone && (
                    <p className="error-custommessage">{errors.phone.message}</p>
                )}
              </td>
            </tr>

            {/* 주소 */}
            <tr>
              <th>주소<span className="requiredcustom">*</span></th>
              <td>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <input
                        type="text"
                        className={`input-customtext ${errors.addr1 ? "error" : ""}`}
                        placeholder="주소를 검색하세요"
                        style={{ width: '300px' }}
                        {...register("addr1")}
                    />
                    <button
                        type="button"
                        className="btn-save"
                        style={{ marginLeft: '8px' }}
                        onClick={() => {
                          new window.daum.Postcode({
                            oncomplete: (data) => {
                              // 주소를 addr1에 반영
                              setValue("addr1", data.address, { shouldValidate: true });
                            },
                          }).open();
                        }}
                    >
                      검색
                    </button>
                  </div>
                  {errors.addr1 && (
                      <p className="error-custommessage">{errors.addr1.message}</p>
                  )}
                  <div>
                    <input
                        type="text"
                        className="input-customtext"
                        placeholder="상세주소"
                        style={{ width: '300px' }}
                        maxLength={50}
                        {...register("addr2")}
                    />
                  </div>
                </div>
              </td>
              <th>사내규모<span className="requiredcustom">*</span></th>
              <td>
                <select
                    className={`input-customselect ${errors.sizeCategory ? 'error' : ''}`}
                    style={{ width: '300px' }}
                    {...register('sizeCategory')}
                >
                  <option value="">선택</option>
                  <option value="1">50인 미만</option>
                  <option value="2">50인 이상</option>
                </select>
                {errors.sizeCategory && (
                    <p className="error-message">{errors.sizeCategory.message}</p>
                )}
              </td>
            </tr>

            {/* 업태, 종목 */}
            <tr>
              <th>업태<span className="requiredcustom">*</span></th>
              <td>
                <select
                    className={`input-customselect ${errors.bizType ? "error" : ""}`}
                    style={{ width: '200px' }}
                    {...register("bizType")}
                >
                  <option value="">선택</option>
                  {bizTypeList.map((b) => (
                    <option key={b.comdCode} value={b.comdCode}>{b.comdName}</option>
                  ))}
                </select>
                {errors.bizType && (
                    <p className="error-message">{errors.bizType.message}</p>
                )}
              </td>
              <th>종목</th>
              <td>
                <input
                    type="text"
                    className="input-customtext"
                    placeholder="종목"
                    style={{ width: '300px' }}
                    maxLength={50}
                    {...register("bizItem")}
                />
              </td>
            </tr>

            {/* 비고 */}
            <tr>
              <th>비고</th>
              <td colSpan={3}>
                <div style={{ textAlign: 'right', marginBottom: '4px' }}>
                  {noticeLength}/666
                </div>
                <textarea
                    className={`input-customtextarea ${errors.notice ? "error" : ""}`}
                    rows={3}
                    style={{ width: '100%' }}
                    maxLength={666}
                    {...register("notice")}
                />
                {errors.notice && (
                    <p className="error-message">{errors.notice.message}</p>
                )}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </FormProvider>
      </>
  );
};
